import React, {useEffect, useRef, useState} from 'react';
import ReactDOM from 'react-dom';

function Autocomplete ({googleMap, map, placeChanged, updateHasAutocomplete, inputRef, showFilter}) {
    const center = { lat: 50.064192, lng: -130.605469 };
    const [autocomplete , setAutocomplete] = useState(null);
    const [style, setStyle] = useState({});
    const options = {
        componentRestrictions: { country: "fr" },
    };

    useEffect(() => {
        if(showFilter) {
            setStyle({
                position:'absolute',
                visibility:'hidden',
            })
        }else {
            setStyle({
                position:'relative',
                visibility:'initial',
            })
        }
    }, [showFilter])
    useEffect(() => {
        if(inputRef.current && googleMap) {
            setAutocomplete(new googleMap.maps.places.Autocomplete(inputRef.current, options));
        }

    }, [inputRef.current, googleMap])

    useEffect(() => {
        if(autocomplete && map) {
            autocomplete.addListener("place_changed", function() {
                placeChanged(autocomplete.getPlace());
            })

            autocomplete.bindTo('bounds', map);

            return () => {
                autocomplete.removeListener("place_changed")
            }
        }


    }, [map, autocomplete])
    return (<div style={style} className="input">
        <input placeholder="Ville" onKeyUp={(e) => {
            if(e.currentTarget.value === "") {
                updateHasAutocomplete(false);
            }else {
                updateHasAutocomplete(true);
            }
        }
        } ref={inputRef} />
        <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path  d="M12.3181 21.6C7.46123 21.6 3.51945 17.6576 3.51945 12.8C3.51945 7.94766 7.46123 3.99998 12.3181 3.99998C17.1749 3.99998 21.1167 7.94766 21.1167 12.8C21.1167 17.6576 17.1749 21.6 12.3181 21.6ZM27.6453 25.6304L22.1549 20.192C23.7035 18.1328 24.6362 15.5808 24.6362 12.8C24.6362 6.00814 19.1106 0.47998 12.3181 0.47998C5.52554 0.47998 0 6.00814 0 12.8C0 19.5936 5.52554 25.12 12.3181 25.12C15.0984 25.12 17.65 24.1872 19.7089 22.6384V22.656L25.1465 28.1296C25.4984 28.464 25.9383 28.64 26.3959 28.64C26.8534 28.64 27.2933 28.464 27.6453 28.1296C28.3316 27.4432 28.3316 26.3168 27.6453 25.6304Z" fill="black"/>
        </svg>

    </div>);
}


export default Autocomplete;
